import { Progress } from "@material-tailwind/react";

export function ProgressDefault() {
  return <Progress value={50} />;
}
